import { duration } from "moment";
import { apiSlice } from "./apiSlice";

export const irrViewSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        getAllIrr: builder.query({
            query: (params) => ({
                url: `IRRView`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["IrrTracker"],
        }),


        // getSingleIrrDetails: builder.query({
        //     query: ({ IncidentTracker, params }) => ({
        //         url: `IncidentTracker/${IncidentTracker}`,
        //         params,
        //     }),
        //     keepUnusedDataFor: 0,
        //     refetchOnMountOrArgChange: true,
        // }),

        createIrr: builder.mutation({
            query: ({ body }) => ({
                url: `IRRView`,
                method: "POST",
                body,
            }),
            invalidatesTags: ["IrrTracker"],
        }),

        updateIrr: builder.mutation({
            query: ({ body }) => ({
                url: `IRRView`,
                method: "PUT",
                body,
            }),
            invalidatesTags: ["IrrTracker"],
        }),


        // getAllIrrCount: builder.query({
        //     query: (params) => ({
        //         url: `IncidentTracker/summary`,
        //         params,
        //     }),
        //     invalidatesTags: ["Incident"],
        // }),
        getExportIRR: builder.query({
            query: (params) => ({
                url: `IRRView`,
                params,
            }),
            keepUnusedDataFor: 0,
        }),



    }),
});

export const {
    useCreateIrrMutation, useLazyGetAllIrrQuery, useGetAllIrrQuery, useUpdateIrrMutation, useLazyGetExportIRRQuery
} = irrViewSlice;